/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Epiteto', Epiteto);

    /* @ngInject */
    function Epiteto($resource) {
        return $resource('api/admin/epiteto/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/epiteto/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/epiteto/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/epiteto/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/epiteto/findUsedLetters'
            }
        });
    }
})();
